// Components/HighlightPickerModal.jsx
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from "@heroui/react";
import { useEffect, useState } from "react";

const MAX = 4;

export default function HighlightPickerModal({ isOpen, onClose, backendContext, initialSelection = [], onSave }) {
  const [owned, setOwned] = useState([]);         // [{id, page, thumbnail?}]
  const [sel, setSel] = useState(initialSelection.slice(0, MAX));

  useEffect(() => setSel(initialSelection.slice(0, MAX)), [initialSelection]);

  useEffect(() => {
    if (!isOpen) return;
    (async () => {
      // you already have backendContext.fetchUserArtworks() in Layout; you can reuse it
      const list = backendContext.userArtwork || await backendContext.fetchUserArtworks();
      // map to small view
      setOwned(list.map(a => ({
        id: a.id,
        page: a.page,
        thumb: a.thumbnail ?? a.imageData ?? null,
      })));
    })();
  }, [isOpen]);

  const toggle = (id) => {
    setSel(prev => {
      if (prev.includes(id)) return prev.filter(x => x !== id);
      if (prev.length >= MAX) return prev; // enforce limit
      return [...prev, id];
    });
  };

  const commit = async () => {
    // keep current order as tile order (first = order 0)
    await onSave(sel);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} backdrop="blur" classNames={{ base: "bg-slate-900 text-white" }}>
      <ModalContent>
        <ModalHeader className="text-lg font-semibold">Pick up to {MAX} highlights</ModalHeader>
        <ModalBody>
          <div className="grid grid-cols-4 gap-3">
            {owned.map(a => {
              const active = sel.includes(a.id);
              return (
                <button key={a.id}
                        onClick={() => toggle(a.id)}
                        className={`aspect-square rounded border overflow-hidden ${active ? 'ring-2 ring-indigo-400' : 'border-slate-700'}`}>
                  {a.thumb ? (
                    <img src={`data:image/png;base64,${a.thumb}`} alt="" className="w-full h-full object-contain" style={{ imageRendering: 'pixelated', border: '1px solid black' }}/>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-500">#{a.id.slice(-4)}</div>
                  )}
                </button>
              );
            })}
          </div>
          <div className="text-xs text-gray-400 mt-2">Selected: {sel.length}/{MAX}</div>
        </ModalBody>
        <ModalFooter>
          <Button variant="flat" onPress={onClose}>Cancel</Button>
          <Button color="primary" onPress={commit} isDisabled={!sel.length}>Save</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
